const productAddResources = [
    {
        name: 'Product News and Updates',
        slug: 'product-news-and-updates/',
    },
    {
        name: 'Availability Map',
        slug: 'product-availability-map/',
    },
    {
        name: 'Product Offerings',
        slug: '/training-and-job-aids/job-aids/our-product-offerings/',
    },
];

export default productAddResources;
